import { UnifiedAccServiceComponent } from './UnifiedAccServiceComponent';
import { UnifiedAccReconnectButton } from './UnifiedAccReconnectButton';
import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
export const UnifiedAccReconnectionConfig = {
  reconnectButton: UnifiedAccReconnectButton,
  serviceComponent: UnifiedAccServiceComponent,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED]
};